import { ListTagCategoriesQuery } from "@/graphql/graphql";
import { manageInterest } from "@/graphql/mutations";
import { listTagCategories } from "@/graphql/queries";
import { GraphQLQuery } from "@aws-amplify/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API } from "aws-amplify";

interface IUpsertInterest {
  categoryId?: string;
  categoryName?: string;
  isDeleted?: boolean;
  interests?: {
    id?: string;
    name?: string;
    isDeleted?: boolean;
  }[];
}

export interface IInterests {
  id?: string | null;
  organizationGroup?: string | null;
  name?: string | null;
  tags?: {
    items: {
      __typename: "Tag";
      id?: string | null;
      organizationGroup?: string | null;
      name?: string | null;
      description?: string | null;
      type: string;
      category?: string | null;
      tagCategoryId?: string | null;
      createdAt: string;
      updatedAt: string;
      _version: number;
      _deleted?: boolean | null;
      _lastChangedAt: number;
    }[] | null;
    nextToken?: string | null;
    startedAt?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  _version: number;
  _deleted?: boolean | null;
  _lastChangedAt: number;
}

export async function getListInterests(organizationGroup: string) {
  const records = (await API.graphql<GraphQLQuery<any>>({
    query: listTagCategories,
    variables: {
      filter: { organizationGroup: { eq: organizationGroup } },
      limit: 1000,
    },
  })) as { data: ListTagCategoriesQuery };
  return (records.data?.listTagCategories?.items || []) as IInterests[];
}

export const useListInterests = (organizationGroup: string) => {
  return useQuery({
    queryKey: [`KEY_LIST_THE_INTERESTS`, organizationGroup],
    queryFn: async () => await getListInterests(organizationGroup),
    enabled: !!organizationGroup,
  });
};

export const useManageInterest = () => {
  return useMutation({
    mutationKey: [`KEY_UPSERT_INTEREST`],
    mutationFn: async (payload: IUpsertInterest) => {
      const records: any = await API.graphql<GraphQLQuery<any>>({
        query: manageInterest,
        variables: payload,
      });
      return records;
    },
  });
};
